import { Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { GlobalSearch } from "./global-search";
import { TenantSwitcher } from "./tenant-switcher";
import { Notifications } from "./notifications";
import { OnlineAdmins } from "./online-admins";
import { AiAssistantTrigger } from "@/components/ai-assistant";
import { cn } from "@/lib/utils";

/**
 * Header component with breadcrumbs and user actions
 */
interface HeaderProps {
  onMenuClick?: () => void;
  onAiAssistantClick?: () => void;
  className?: string;
}

export function Header({ onMenuClick, onAiAssistantClick, className }: HeaderProps) {
  return (
    <header
      className={cn(
        "flex h-16 items-center border-b border-border bg-card px-4 lg:px-6 gap-4",
        className
      )}
    >
      {/* Left: Mobile Menu + Tenant Switcher */}
      <div className="flex shrink-0 items-center gap-2">
        <Button
          variant="ghost"
          size="icon"
          className="lg:hidden"
          onClick={onMenuClick}
        >
          <Menu className="h-5 w-5" />
        </Button>
        <TenantSwitcher />
      </div>

      {/* Center: Global Search */}
      <div className="flex flex-1 items-center justify-center">
        <GlobalSearch />
      </div>

      {/* Right: Actions */}
      <div className="flex shrink-0 items-center gap-2">
        <OnlineAdmins />

        {/* AI Assistant Button */}
        {onAiAssistantClick && (
          <AiAssistantTrigger
            variant="header"
            onClick={onAiAssistantClick}
          />
        )}

        <Notifications />
      </div>
    </header>
  );
}
